module.exports = __webpack_public_path__ + "static/img/6712_phase_function_Paper_PointsHejduk_Prediction.7ed71fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6712_phase_function_Paper_PointsHejduk_Prediction.png
// module id = nun4
// module chunks = 0